import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import ModalForm from "../../Components/ModalForm";
import MyInput from "../../Components/Myinput";
import API from "../../Api/axiosConfig";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Can from "../../Components/Can";
import PremiumUploader from "../../Components/PremiumUploader";
import { Eye, SquarePen } from "lucide-react";
import { Accordion } from "react-bootstrap";
import { NegativeNumberDisplay } from "../../utils/formatNegativeNumber";
import { Tabs, Tab } from "react-bootstrap";
import { toLocal } from "../../utils/toLocal";

function Employees() {
  const { t } = useTranslation();
  // Removed inspectionImagePreview state

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
  // Personal
  name: "",
  email: "",
  password: "",
  password_confirmation: "",
  // age: "",
  birth_date: "",
  gender: "",
  nationality: "",
  marital_status: "",
  national_id: "",
  phone: "",
  address: "",

  // Job
  branch_id: "",
  job_number: "",
  qualification: "",
  join_date: "",
  description: "",
  active: true,

  // Financial
  salary: "",
  additional_salary: "",
  allowances: "",
  social_insurance: "",
  health_insurance: "",
  total_salary: "",

  attachment: null,
  attachment_preview: null,
});
  const [branches, setBranches] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [editId, setEditId] = useState(null);

  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);
const [showViewModal, setShowViewModal] = useState(false);
const [selectedEmployee, setSelectedEmployee] = useState(null);
  useEffect(() => {
    API.get("/branches")
      .then((res) => setBranches(res.data.data || []))
      .catch((err) => console.error("Failed to load branches", err));
  }, []);

  const handleAdd = () => {
    setFormData({
      // Personal
  name: "",
  email: "",
  password: "",
  password_confirmation: "",
  // age: "",
  birth_date: "",
  gender: "",
  nationality: "",
  marital_status: "",
  national_id: "",
  phone: "",
  address: "",

  // Job
  branch_id: "",
  job_number: "",
  qualification: "",
  join_date: "",
  description: "",
  active: true,

  // Financial
  salary: "",
  additional_salary: "",
  allowances: "",
  social_insurance: "",
  health_insurance: "",
  total_salary: "",

  attachment: null,
  attachment_preview: null,
    });
    setEditId(null);
    setErrors({});
    setShowModal(true);
  };

  const handleEdit = (employee) => {
    setFormData({
      ...employee,
      attachment_preview: employee.attachment ? employee.attachment : null, // Set preview if attachment exists
    });
    setEditId(employee.uuid);
    setErrors({});
    setShowModal(true);
  };

  const handleDeleteClick = (uuid) => {
    setDeleteId(uuid);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setDeleting(true);
    try {
      await API.delete(`/employees/${deleteId}`);
      console.log(t("employees_deleteSuccess"));
      setRefreshKey((prev) => prev + 1);
      setShowDeleteModal(false);
      setDeleteId(null);
    } catch (err) {
      console.error(err);
      toast.error(t("employees_deleteFail"));
    } finally {
      setDeleting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Client-side validation
    let newErrors = {};
    if (!formData.name) newErrors.name = [t("field_required")];
    if (!formData.national_id) newErrors.national_id = [t("field_required")];
    if (!formData.salary) newErrors.salary = [t("field_required")];
    if (!formData.phone) newErrors.phone = [t("field_required")];
if (!formData.email) newErrors.email = [t("field_required")];

// الباسورد إلزامي بس وقت الإضافة، مش وقت التعديل
if (!editId) {
  if (!formData.password) newErrors.password = [t("field_required")];
  if (!formData.password_confirmation) newErrors.password_confirmation = [t("field_required")];
}

// لو في التعديل المستخدم كتب باسورد جديد، يبقى لازم يأكده
if (editId && formData.password && !formData.password_confirmation) {
  newErrors.password_confirmation = [t("field_required")];
}

// تأكيد إن الباسورد والتأكيد متطابقين لو اتكتبوا
if (formData.password && formData.password_confirmation && formData.password !== formData.password_confirmation) {
  newErrors.password_confirmation = [t("password_mismatch") || "كلمة المرور غير متطابقة"];
}

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);

      return;
    }

    setLoading(true);
    setErrors({});

    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "attachment_preview") return;

      let value = formData[key];

      // Standardize boolean fields for backend (often expect 1/0)
      if (key === "active") {
        value = value === true || value === 1 || value === "1" ? "1" : "0";
      }

      if (key === "attachment") {
        if (value instanceof File) data.append(key, value);
      } else if (value !== null && value !== "" && value !== undefined) {
        data.append(key, value);
      }
    });

    try {
      if (editId) {
        await API.post(`/employees/${editId}?_method=PUT`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success(t("employees_updateSuccess"));
      } else {
        await API.post("/employees", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success(t("employees_addSuccess"));
      }
      setShowModal(false);
      setRefreshKey((prev) => prev + 1);
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
        // Improved error display: Show all validation error messages from the backend
        Object.keys(err.response.data.errors).forEach((field) => {
          err.response.data.errors[field].forEach((msg) => {
            toast.error(`${t(`employees_${field}`) || field}: ${msg}`);
          });
        });
      } else {
        console.log(err.response?.data?.message || err.message || t("employees_addFail") || "Submission failed")
        // toast.error(err.response?.data?.message || err.message || t("employees_addFail") || "Submission failed");
      }
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { header: t("employees_name"), accessor: "name" },
    { header: t("employees_branch"), accessor: "branch.name" },
    { header: t("employees_age"), accessor: "age" },
    {
      header: t("employees_gender"),
      accessor: (row) =>
        row.gender === "male"
          ? t("employees_male")
          : row.gender === "female"
            ? t("employees_female")
            : "-",
    },
    { header: t("employees_nationalId"), accessor: "national_id" },
    { header: t("employees_phone"), accessor: "phone" },
    { header: t("employees_address"), accessor: "address" },
    {
      header: t("employees_salary"),
      accessor: (row) => <NegativeNumberDisplay value={row.salary} />,
    },
    {
      header: t("employees_status"),
      accessor: (row) =>
        row.active ? t("employees_active") : t("employees_inactive"),
    },
    {
      header: t("employees_actions"),
      accessor: (row) => (
        <div style={{width:"fit-content"}} className="d-flex border mx-auto rounded">
          <Can permission="employee_show">
            <button
              className="btn btn-sm btn-primary mx-1 no-style"
              onClick={()=>{
                setSelectedEmployee(row);
                setShowViewModal(true);
              }}
            >
              <Eye size={16} />
            </button>
          </Can>
          <Can permission="employee_update">
            <button
              className="btn btn-sm btn-primary mx-1 no-style"
              onClick={() => handleEdit(row)}
            >
              <SquarePen />
            </button>
          </Can>
          
          <Can permission="employee_delete">
            <button
              className="btn btn-sm btn-danger no-style"
              onClick={() => handleDeleteClick(row.uuid)}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </Can>
        </div>
      ),
      hideOnPrint: true,
    },
  ];

  return (
    <div className="container mt-5">
      <Mytitle title={t("employees_title")} />

      <ModalForm
  show={showModal}
  onClose={() => setShowModal(false)}
  title={`${editId ? t("employees_editTitle") : t("employees_addTitle")} ${formData?.name || ""}`}
  onSubmit={handleSubmit}
  loading={loading}
  mode="form"
  size="lg"
>

  {/* الحالة والفرع */}
  <div className="row mb-3">
    {editId && (
      <div className="col-md-6">
        <MyInput
          value={formData.active}
          onChange={(e) =>
            setFormData({ ...formData, active: e.target.value })
          }
          error={errors.active?.[0]}
          as="select"
          options={[
            { value: "", label: t("employees_selectStatus") },
            { value: 1, label: t("employees_active") },
            { value: 0, label: t("employees_inactive") }
          ]}
        />
      </div>
    )}

    <div className={editId ? "col-md-6" : "col-md-12"}>
      <MyInput
        label={t("employees_branch")}
        value={formData.branch_id}
        onChange={(e) =>
          setFormData({ ...formData, branch_id: e.target.value })
        }
        error={errors.branch_id?.[0]}
        as="select"
        options={[
          {
            value: "",
            label: t("employees_select_branch")
          },
          ...branches.map(b => ({
            value: b.uuid,
            label: b.name
          }))
        ]}
      />
    </div>
  </div>

  {/* ================= التبويبات (Tabs) ================= */}
  <Tabs defaultActiveKey="personal" id="employee-form-tabs" className="mb-4 justify-content-start">

    {/* ================= البيانات الشخصية ================= */}
    <Tab eventKey="personal" title={t("personal_data")}>
      <div className="p-3 border border-top-0 rounded-bottom">
        <div className="row">
          <div className="col-md-6 mb-3">
            <MyInput
              label={t("employees_name")}
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              error={errors.name?.[0]}
              required
            />
          </div>

          {/* <div className="col-md-6 mb-3">
            <MyInput
              label={t("employees_age")}
              type="number"
              value={formData.age}
              onChange={(e) =>
                setFormData({ ...formData, age: e.target.value })
              }
            />
          </div> */}

          <div className="col-md-6 mb-3">
            <MyInput
              label={t("birth_date")}
              type="date"
              value={formData.birth_date}
              onChange={(e) =>
                setFormData({ ...formData, birth_date: e.target.value })
              }
            />
          </div>

          <div className="col-md-6 mb-3">
            <MyInput
              label={t("employees_gender")}
              as="select"
              value={formData.gender}
              onChange={(e) =>
                setFormData({ ...formData, gender: e.target.value })
              }
              options={[
                { value: "", label: "اختر" },
                { value: "male", label: t("employees_male") },
                { value: "female", label: t("employees_female") }
              ]}
            />
          </div>

          <div className="col-md-6 mb-3">
            <MyInput
              label={t("nationality")}
              value={formData.nationality}
              onChange={(e) =>
                setFormData({ ...formData, nationality: e.target.value })
              }
            />
          </div>

          <div className="col-md-6 mb-3">
            <MyInput
              label={t("employees_phone")}
              value={formData.phone}
              onChange={(e) =>
                setFormData({ ...formData, phone: e.target.value })
              }
              error={errors.phone?.[0]}
              required
            />
          </div>

          <div className="col-md-6 mb-3">
            <MyInput
              label={t("employees_nationalId")}
              type="number"
              value={formData.national_id}
              onChange={(e) =>
                setFormData({ ...formData, national_id: e.target.value })
              }
              error={errors.national_id?.[0]}
            />
          </div>

          <div className="col-md-12 mb-3">
            <MyInput
            defaultValue={formData.address || ""}
            type="address"
              label={t("employees_address")}
              value={formData.address}
              onChange={(e) =>
                setFormData({ ...formData, address: e.target.value })
              }
            />
          </div>
        </div>
      </div>
    </Tab>

    {/* ================= تابة الحساب (جديدة) ================= */}
    <Tab eventKey="account" title={t("account_data") || "بيانات الحساب"}>
      <div className="p-3 border border-top-0 rounded-bottom">
        <div className="row">
          <div className="col-md-12 mb-3">
            <MyInput
              label={t("email")}
              type="email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              error={errors.email?.[0]}
              required
            />
          </div>

          <div className="col-md-6 mb-3">
            <MyInput
              label={t("password") || "كلمة المرور"}
              type="password"
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
              error={errors.password?.[0]}
            />
          </div>

          <div className="col-md-6 mb-3">
            <MyInput
              label={t("password_confirmation") || "تأكيد كلمة المرور"}
              type="password"
              value={formData.password_confirmation}
              onChange={(e) =>
                setFormData({ ...formData, password_confirmation: e.target.value })
              }
              error={errors.password_confirmation?.[0]}
            />
          </div>
        </div>
      </div>
    </Tab>

    {/* ================= البيانات الوظيفية ================= */}
    <Tab eventKey="job" title={t("job_data")}>
      <div className="p-3 border border-top-0 rounded-bottom">
        <div className="row">
          <div className="col-md-6 mb-3">
            <MyInput
              label={t("job_number")}
              value={formData.job_number}
              onChange={(e) =>
                setFormData({ ...formData, job_number: e.target.value })
              }
            />
          </div>

          <div className="col-md-6 mb-3">
            <MyInput
              label={t("join_date")}
              type="date"
              value={formData.join_date}
              onChange={(e) =>
                setFormData({ ...formData, join_date: e.target.value })
              }
            />
          </div>

          <div className="col-md-12 mb-3">
            <MyInput
              label={t("qualification")}
              value={formData.qualification}
              onChange={(e) =>
                setFormData({ ...formData, qualification: e.target.value })
              }
            />
          </div>

          <div className="col-md-12 mb-3">
            <MyInput
              label={t("description")}
              type="textarea"
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
            />
          </div>
        </div>
      </div>
    </Tab>

    {/* ================= البيانات المالية ================= */}
    <Tab eventKey="financial" title={t("financial_data")}>
      <div className="p-3 border border-top-0 rounded-bottom">
        <div className="row">
          {[
            ["salary", "salary"],
            ["additional_salary", "additional_salary"],
            ["allowances", "allowances"],
            ["social_insurance", "social_insurance"],
            ["health_insurance", "health_insurance"],
            ["total_salary", "total_salary"]
          ].map(([key, label]) => (
            <div className="col-md-6 mb-3" key={key}>
              <MyInput
                label={t(label)}
                type="number"
                value={formData[key]}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    [key]: e.target.value
                  })
                }
                error={errors[key]?.[0]}
              />
            </div>
          ))}
        </div>
      </div>
    </Tab>

  </Tabs>

  {/* ================= المرفقات ================= */}
  <div className="row mt-4">
    <div className="col-md-12 d-flex justify-content-center">
      <PremiumUploader
        title={t("attachments")}
        name="attachment"
        preview={formData.attachment_preview}
        onDelete={() => {
          setFormData({
            ...formData,
            attachment: null,
            attachment_preview: null
          })
        }}
        onChange={(e) => {
          if (e.target.files?.[0]) {
            setFormData({
              ...formData,
              attachment: e.target.files[0],
              attachment_preview: URL.createObjectURL(e.target.files[0])
            })
          }
        }}
        accept="image/*"
      />
    </div>
  </div>

</ModalForm>

      <ModalForm
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title={t("employees_deleteTitle")}
        onSubmit={confirmDelete}
        loading={deleting}
        mode="confirm"
        confirmText={t("employees_deleteConfirm")}
        cancelText={t("employees_cancel")}
      >
        {t("employees_deleteQuestion")}
      </ModalForm>

     <ModalForm
  show={showViewModal}
  onClose={() => setShowViewModal(false)}
  title={`${t("employee_details")} (${selectedEmployee?.name || ""})`}
  mode="print"
  size="lg"
>
  {selectedEmployee && (
    <div className="row p-3">

      {/* البيانات الشخصية */}
      <hr />
      <h5 className="mb-3 col-12"> {/* أضفنا col-12 لضمان بقاء العنوان في سطر مستقل */}
        {t("personal_data")}
      </h5>

      {/* تم تغيير col-md-6 إلى col-6 لتظهر اثنين في الصف دائماً */}
      <div className="col-6 mb-3">
        <label className="fw-bold">{t("employees_name")}:</label>
        <p className="border-bottom pb-2">{selectedEmployee.name || "-"}</p>
      </div>

      <div className="col-6 mb-3">
        <label className="fw-bold">{t("email")}:</label>
        <p className="border-bottom pb-2">{selectedEmployee.email || "-"}</p>
      </div>

      <div className="col-6 mb-3">
        <label className="fw-bold">{t("employees_phone")}:</label>
        <p className="border-bottom pb-2">{selectedEmployee.phone || "-"}</p>
      </div>

      <div className="col-6 mb-3">
        <label className="fw-bold">{t("employees_nationalId")}:</label>
        <p className="border-bottom pb-2">{selectedEmployee.national_id || "-"}</p>
      </div>

      <div className="col-6 mb-3">
        <label className="fw-bold">{t("nationality")}:</label>
        <p className="border-bottom pb-2">{selectedEmployee.nationality || "-"}</p>
      </div>

      <div className="col-6 mb-3">
        <label className="fw-bold">{t("birth_date")}:</label>
        <p className="border-bottom pb-2">{selectedEmployee.birth_date || "-"}</p>
      </div>


      {/* البيانات الوظيفية */}
      <hr />
      <h5 className="mb-3 col-12">
        {t("job_data")}
      </h5>

      <div className="col-6 mb-3">
        <label className="fw-bold">{t("job_number")}:</label>
        <p className="border-bottom pb-2">{selectedEmployee.job_number || "-"}</p>
      </div>

      <div className="col-6 mb-3">
        <label className="fw-bold">{t("branch")}:</label>
        <p className="border-bottom pb-2">{selectedEmployee.branch?.name || "-"}</p>
      </div>

      <div className="col-6 mb-3">
        <label className="fw-bold">{t("qualification")}:</label>
        <p className="border-bottom pb-2">{selectedEmployee.qualification || "-"}</p>
      </div>

      <div className="col-6 mb-3">
        <label className="fw-bold">{t("join_date")}:</label>
        <p className="border-bottom pb-2">{selectedEmployee.join_date || "-"}</p>
      </div>

      <div className="col-12 mb-3"> {/* الوصف يفضل أن يظل بكامل العرض */}
        <label className="fw-bold">{t("description")}:</label>
        <p className="border-bottom pb-2">{selectedEmployee.description || "-"}</p>
      </div>


      {/* البيانات المالية */}
      <hr />
      <h5 className="mb-3 col-12">
        {t("financial_data")}
      </h5>

      {/* إذا كنت تريد المالية أيضاً 2 في الصف، غير col-md-4 إلى col-6 */}
      <div className="col-6 mb-3">
        <label className="fw-bold">{t("salary")}:</label>
        <p className="border-bottom pb-2">{toLocal(selectedEmployee.salary) || 0}</p>
      </div>

      <div className="col-6 mb-3">
        <label className="fw-bold">{t("additional_salary")}:</label>
        <p className="border-bottom pb-2">{toLocal(selectedEmployee.additional_salary) || 0}</p>
      </div>

      <div className="col-6 mb-3">
        <label className="fw-bold">{t("total_salary")}:</label>
        <p className="border-bottom pb-2">{toLocal(selectedEmployee.total_salary) || 0}</p>
      </div>


      {/* المرفق */}
      {selectedEmployee.attachment && (
        <div className="col-12 mt-3">
          <label className="fw-bold">{t("attachments")}:</label>
          <br />
          <img
            src={selectedEmployee.attachment}
            alt="attachment"
            style={{
              width: "150px",
              borderRadius: "10px"
            }}
          />
        </div>
      )}

    </div>
  )}
</ModalForm>

      <MyTable
        resource="employees"
        title={t("employees_title")}
        columns={columns}
        refreshKey={refreshKey}
        filters={[
          { type: "text", name: "name", label: t("employees_searchByName") },
          {
            type: "select",
            name: "active",
            label: t("employees_status"),
            options: [
              { value: "", label: t("employees_all") },
              { value: 1, label: t("employees_active") },
              { value: 0, label: t("employees_inactive") },
            ],
          },
        ]}
        button={{
          text: t("employees_addButton"),
          onClick: handleAdd,
          permission: "employee_create",
        }}
      />
    </div>
  );
}

export default Employees;
